import { ColDef, ColGroupDef } from 'ag-grid-community';
import { ReportRole } from '../../RolePanelTypes';
import { BasePermissionGrid } from './BasePermissionGrid';

export class ReportRoleGrid extends BasePermissionGrid<ReportRole> {
    id: string = 'ReportRoles';
    gridClass: string = 'permissionGrid';
    protected endpoint: string = '/rolePanel/reportRoles';
    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            { field: 'Name', headerName: 'Report Name', flex: 3, resizable: false },
            {
                field: 'AllowSelect',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
            {
                field: 'AllowDesign',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            }
        ];
    }    
}
